import { Loader2 } from 'lucide-react';

const variants = {
  primary: 'bg-primary text-white hover:bg-primary-hover border-transparent',
  secondary: 'bg-card text-text border-border hover:bg-surface',
  ghost: 'bg-transparent text-text border-transparent hover:bg-surface',
  danger: 'bg-danger text-white hover:bg-red-700 border-transparent',
};

const sizes = {
  sm: 'min-h-touch px-3 py-2 text-sm',
  md: 'min-h-touch px-4 py-2.5 text-sm',
  lg: 'min-h-touch px-5 py-3 text-base',
};

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled = false,
  className = '',
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled || isLoading}
      className={`inline-flex items-center justify-center gap-2 rounded-lg border font-medium transition-colors disabled:opacity-50 disabled:pointer-events-none max-w-full ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
}
